import React, { Suspense, lazy } from 'react';

// Simple component loaders that directly return lazy components
const componentLoaders = {

  // Task Management Component
  'TasksPage': lazy(() => import('../pages/TasksPage')),

  // Productivity Coaching Components
  'ProductivityCoachingDashboard': lazy(() => import('../pages/ProductivityCoachingDashboard')),
  'Agents': lazy(() => import('../pages/Agents')),
  'AgentDetail': lazy(() => import('../pages/AgentDetail')),
  'AccountabilityGrid': lazy(() => import('../pages/AccountabilityGrid')),
  'Pipeline': lazy(() => import('../pages/Pipeline')),
  'PipelineDetail': lazy(() => import('../pages/PipelineDetail')),
  'Communications': lazy(() => import('../pages/Communications')),
  'CommunicationDetail': lazy(() => import('../pages/CommunicationDetail')),
  'CommunicationAnalyticsDashboard': lazy(() => import('../pages/CommunicationAnalyticsDashboard')),
  'ClassSchedule': lazy(() => import('../pages/ClassSchedule')),
  'InstructorDirectoryAdmin': lazy(() => import('../pages/InstructorDirectoryAdmin')),
  'Classes': lazy(() => import('../pages/Classes')),
  'ClassEventDetail': lazy(() => import('../pages/ClassEventDetail')),

  
  // Add missing components that might be referenced
  'LaunchSeries': lazy(() => import('../pages/LaunchSeries'))
};

const LoadingSpinner = () => (
  <div className="flex justify-center items-center h-64">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
    <span className="ml-3 text-gray-600">Loading...</span>
  </div>
);

export const getComponent = (componentName) => {
  const LazyComponent = componentLoaders[componentName];
  
  if (!LazyComponent) {
    return () => (
      <div className="text-center py-12">
        <h3 className="text-lg font-medium text-gray-900 mb-2">Component Not Found</h3>
        <p className="text-sm text-gray-500">Could not find component: {componentName}</p>
      </div>
    );
  }

  return (props) => (
    <Suspense fallback={<LoadingSpinner />}>
      <LazyComponent {...props} />
    </Suspense>
  );
};

export default { getComponent };
